/**
 * useAutoFocus — focuses the referenced element once on mount.
 *
 * Used by onboarding wizard form steps to drop the cursor into the first
 * meaningful input as soon as the step renders. Independent of the wizard's
 * heading-focus pass; if both run, parent (wizard) effects fire after the
 * child (step) effect, so the heading still wins for screen-reader users
 * while keyboard users still get a sensible starting input on standalone
 * step renders.
 */

import { useEffect, type RefObject } from 'react'

export function useAutoFocus<T extends HTMLElement>(ref: RefObject<T>): void {
  useEffect(() => {
    ref.current?.focus()
    // Mount-only — focus once when the step appears.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
